import React, {useEffect, useRef, useState} from 'react';

import useLogout from '../../hooks/useLogout';
import styles from './styles/mode-modal.module.css';

export default function ModeModal({ modeList, toggleModeModal, movePage }) {
    const modalRef = useRef(null);
    
    const [hoveredId, setHoveredId] = useState(null);
    const [isOpenSettingModal, setIsOpenSettingModal] = useState(false);

    const logout = useLogout();

    const toggleSettingModal = () => {
        setIsOpenSettingModal(!isOpenSettingModal);
    };

    const clickMode = (path) => {
        if (path === '/setting') {
            toggleSettingModal();
            return;
        }
        
        if (path) {
            movePage(path);
        } else {
            logout();
        }
        
        toggleModeModal();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                toggleModeModal();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [toggleModeModal]);

    return (
        <div ref={modalRef}>
            <div className={styles.wrapper}>
                {modeList.map((mode) => {
                    const { id, path, text, icon, activeIcon } = mode;
                    return (
                        <div 
                            className={styles.mode}
                            key={id} 
                            onClick={() => clickMode(path)}
                            onMouseEnter={() => setHoveredId(id)}
                            onMouseLeave={() => setHoveredId(null)}
                        >
                            {hoveredId === id ? activeIcon : icon}
                            <p>{text}</p>
                        </div>
                    );
                })}
            </div>
            {/* {isOpenSettingModal && <SettingModal closeSettingModal={toggleSettingModal} />} */}
        </div>
    );
}
